import { render } from "./EventProductList.vue?vue&type=template&id=1388e855&scoped=true"
import script from "./EventProductList.vue?vue&type=script&lang=js"
export * from "./EventProductList.vue?vue&type=script&lang=js"

import "./EventProductList.vue?vue&type=style&index=0&id=1388e855&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1388e855"]])

export default __exports__